import React from 'react'
import { getHostHelpers } from '@mobi/betslip/helpers/hostHelpers'
import { updateBetSlipFobRacingItemPrice } from '@mobi/betslip/Store/Bets'
import { refreshAllBets } from '@mobi/betslip/Store/Workflow/asyncActions'
import { isFobSelection } from '@mobi/betslip/helpers/typeGuards'
import { hasPlaceBoostedSuperPick, hasWinBoostedSuperPick } from '@mobi/betslip/helpers/state'

export const useRefreshBoostedSuperPicksOnPriceChange = () => {
  React.useEffect(() => {
    const hostHelpers = getHostHelpers()

    const unsubscribe = hostHelpers.redux.startListening({
      actionCreator: updateBetSlipFobRacingItemPrice,
      effect: (data, listenerApi) => {
        const betSlipItems = listenerApi.getState().betslip.bets.items
        const areBoostedSuperPicksPresent = betSlipItems.some(
          item =>
            isFobSelection(item.selection) &&
            item.selection.propositionSeq === data.payload.propositionId.toString() &&
            (hasWinBoostedSuperPick(item) || hasPlaceBoostedSuperPick(item))
        )

        if (areBoostedSuperPicksPresent)
          listenerApi.dispatch(refreshAllBets({ shouldIgnorePriceChanges: true }))
      },
    })
    return () => unsubscribe()
  }, [])
}
